export const ApiRegisterService = {
  LovedOne: 'lovedone',
  MarketingChannel: 'config/mastercode?code=MARKETING_CHANNEL&size=1000&page=0',
  ProgrammeCategory: 'products/category',
  Order: 'order'
};
